import { Routes } from '@angular/router';

import { DashboardComponent } from './dashboard.component';

export const dashboardRoutes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
];



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.routes.ts